export default {"src":"/_next/static/media/hero-ludziki-highcontrast.2221cae8.svg","height":582,"width":1051};